import React from "react";
import ModalSkeleton from "../../components/ModalSkeleton";
import { LogoutIcon } from "../../constant";
import classes from "./Logout.module.css";
import ModalAction from "../../components/ModalAction";
import { logout } from "../../store/authSlice";
import { useDispatch } from "react-redux";
const LogoutModal = ({ show, setShow }) => {
  const dispatch = useDispatch();
  return (
    <>
      <ModalSkeleton width="500px" show={show} setShow={setShow}>
        <div className={classes.wrapper}>
          <div className={classes.iconWrapper}>
            <LogoutIcon />
          </div>

          <div className={classes.content}>
            <h3 className={classes.heading}>Are Your Sure?</h3>
            <p className={classes.description}>Do you really want to Logout?</p>
          </div>
          <ModalAction
            leftButtonLabel="Cancel"
            leftButtonType="cancel"
            className={classes.bottomCtas}
            onConfirm={() => {
              dispatch(logout());
            }}
            onCancel={() => setShow(false)}
          />
        </div>
      </ModalSkeleton>
    </>
  );
};

export default LogoutModal;
